var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1042 4.02627C11.3492 3.80347 11.6685 3.68 11.9997 3.67999C12.3309 3.67998 12.6502 3.80342 12.8953 4.02621L19.4582 9.99277C19.5955 10.1175 19.7051 10.2696 19.7801 10.4392C19.8552 10.6089 19.8939 10.7923 19.8939 10.9778V19.2187C19.8939 19.5915 19.5917 19.8937 19.2189 19.8937C18.8462 19.8937 18.5439 19.5915 18.5439 19.2187V10.9861L11.9997 5.03658L5.45645 10.9861V19.2187C5.45645 19.5915 5.15424 19.8937 4.78145 19.8937C4.40865 19.8937 4.10645 19.5915 4.10645 19.2187V10.9778C4.10645 10.7923 4.1452 10.6089 4.22023 10.4393C4.29525 10.2696 4.40489 10.1176 4.54212 9.9928L11.1042 4.02627ZM12.0123 5.02518C12.0123 5.02516 12.0123 5.02514 12.0124 5.02512L11.9997 5.01124L12.0124 5.02512L12.0123 5.02518Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1377 19.2187C2.1377 18.846 2.4399 18.5437 2.8127 18.5437H21.1877C21.5605 18.5437 21.8627 18.846 21.8627 19.2187C21.8627 19.5915 21.5605 19.8937 21.1877 19.8937H2.8127C2.4399 19.8937 2.1377 19.5915 2.1377 19.2187Z",
    fill: "#383733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35596 13.9681C9.35596 13.5953 9.65816 13.2931 10.031 13.2931H13.9685C14.3412 13.2931 14.6435 13.5953 14.6435 13.9681V19.2181C14.6435 19.5909 14.3412 19.8931 13.9685 19.8931C13.5957 19.8931 13.2935 19.5909 13.2935 19.2181V14.6431H10.706V19.2181C10.706 19.5909 10.4037 19.8931 10.031 19.8931C9.65816 19.8931 9.35596 19.5909 9.35596 19.2181V13.9681Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a96bbbb83f6bf6a82260df7c8e1bb3c1.svg";
export { ForwardRef as ReactComponent };